module.exports = __webpack_public_path__ + "static/team_dario-6cdeaa7d13ebaf9a620208437d0f9390.jpg";